<template>
  <div class="culture" >
    <div class="culture-title">
      <span>企业文化</span>
    </div>
    <div class="culture-content">
      <el-image :src="'http://'+UrLPhoto"></el-image>
    </div>
  </div>
</template>
<script>
  export default {
    name: "CompanyCulture",

    data(){
      return{
        UrLPhoto:{},
      }
    },
    mounted() {
      this.GetChangeUI()
    },
    created() {
      this.GetData()
    },
    methods:{
      GetChangeUI(){
        const Element=document.querySelector('.culture-content');
        Element.classList.add('animate__animated', 'animate__fadeInDown','animate__slower');
      },
      GetData(){
        this.$axios.get('/api/companyIntro/getById?id=1').then(res=>{

          this.Data=res.data.data
          // // this.ItemDes=this.Data.description;
          // // this.ItemImg=this.Data.introPhotoUrl;
          this.UrLPhoto=this.Data.culturePhotoUrl;

        })
      },
    }
  }
</script>

<style lang="less" scoped>
  .culture{
    width: 74.5vw;
    margin: 0 auto;
    .culture-title{
      margin: 30px 0;
      text-align: center;
      span{
        //width: 132px;
        height: 32px;
        font-size: 32px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #333333;
        line-height: 48px;
        letter-spacing: 1px;
      }
    }
    .culture-content{
      padding-top: 20px;
    }
  }
</style>